import { render, staticRenderFns } from "./UngivenPayment.vue?vue&type=template&id=d353b81c&"
import script from "./UngivenPayment.vue?vue&type=script&lang=js&"
export * from "./UngivenPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports